module.exports = __webpack_public_path__ + "media/Loops 110 Bass.26db04dd.wav";